export const localStorageTargetBundleVersionKey = 'targetBundleVersion';

export enum FirmwareUpdateStep {
  START = 'START',
  VERIFICATION = 'VERIFICATION',
  ONE_TIME_APPROVAL = 'ONE_TIME_APPROVAL',
  LOADING = 'LOADING',
  UP_TO_DATE = 'UP_TO_DATE',
  PREPARATION = 'PREPARATION',
}

export enum BundleUpdateProcessType {
  CHECK_FOR_BUNDLE_UPDATE = 'check_for_bundle_update',
  BUNDLE_UPDATE = 'bundle_update',
}

export enum BundleUpdateProgress {
  SCHEDULED = 'scheduled',
  ONGOING = 'ongoing',
  FINISHED = 'finished',
}

export enum BundleUpdateStatus {
  SUCCESSFUL = 'successful',
  FAILED = 'failed',
}

export interface FirmwareUpdateStatusStartConstraints {
  isSoftwareCorrect: boolean;
  canProceed: boolean;
  isGatewayAllowed: boolean;
  isEveryRequestSuccessful: boolean;
}
